import { render, staticRenderFns } from "./SidebarItemChild.vue?vue&type=template&id=b331aeb6&scoped=true&"
import script from "./SidebarItemChild.vue?vue&type=script&lang=js&"
export * from "./SidebarItemChild.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemChild.vue?vue&type=style&index=0&id=b331aeb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b331aeb6",
  null
  
)

export default component.exports